// extracted by mini-css-extract-plugin
export default {"het-modal__container":"styles_het-modal__container__lt2Lj","title":"styles_title__-tirg","description":"styles_description__tzkHM"};